"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fab.default;
  }
});

var _Fab = _interopRequireDefault(require("./Fab"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Fab/index.js
// module id = 384
// module chunks = 0